import { render, staticRenderFns } from "./NftItem.vue?vue&type=template&id=3288ab72&scoped=true&"
import script from "./NftItem.vue?vue&type=script&lang=js&"
export * from "./NftItem.vue?vue&type=script&lang=js&"
import style0 from "./NftItem.vue?vue&type=style&index=0&id=3288ab72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288ab72",
  null
  
)

export default component.exports